import { Settings } from './settings.model';

export const DEFAULT_SETTINGS: Settings = {
  defaultSettings: {},
  order: {
    timeouts: {
      dispensing: 300000,
      loading: 300000,
      reclaiming: 300000,
      removing: 300000,
    },
  },
  accessCode: {
    allowAlphanumeric: false,
    length: {
      minimum: 4,
      maximum: 6,
    },
    generatedCodeLength: 6,
  },
  device: {
    isActivated: true,
    guidedLoadFailForward: false,
    validatePresenceSensor: true,
    killSwitch: {
      mode: 'off',
      warningStartedAt: '',
      warningGracePeriodDays: 30,
    },
  },
  apps: {
    frodo: {
      style: {
        primaryColor: '#007698',
        secondaryColor: '#14B0C3',
        thirdColor: '#F8971D',
        primaryFontColor: '#FFFFFF',
        secondaryFontColor: '#FFFFFF',
        thirdFontColor: '#FFFFFF',
        fourthFontColor: '#007698',
        fifthFontColor: '#00b5cc',
        logo: './../../assets/logo.png',
        icons: {
          phone: './../../../../assets/phone.svg',
          scan: './../../../../assets/scan.svg',
          order: './../../../../assets/order.svg',
          deliveryList: './../../../../assets/order-list.svg',
          onlineConnection: './../../../../assets/online-icon.svg',
          offlineConnection: './../../../../assets/offline-icon.svg',
          logoIcon: './../../../../assets/logo-icon.svg',
          helpButton: './../../../../assets/helpButton.svg',
          cardOutline: './../../../../assets/cardOutline.svg',
          homeButton: './../../../../assets/homeButton.svg',
          deliver: './../../../../assets/deliver.svg',
          reclaim: './../../../../assets/reclaim.svg',
          status: './../../../../assets/locker-status.svg',
          language: './../../../assets/network.svg',
        },
      },
      timeouts: {
        confirmation: 3000,
        guidedOnloadOrder: 40000,
        guidedOffloadOrder: 6000,
        associateTimeout: 60000,
        cancelRemoveTimeout: 30000,
        removeLightsTimeout: 10000,
        serviceSessionTimeout: 90000,
        deliveryProvider: 15000,
      },
      homescreen: {
        enable: false,
        country: 'US',
        availableScreens: ['mobile', 'scan', 'order-id', 'delivery-list'],
        defaultScreen: 'mobile',
      },
      launchScreen: {
        prescriptiveMessage: 'Press the Begin button to start loading',
        frictionlessMessage: 'Place an object to begin loading',
        enable: true,
      },
      flf: {
        password: '12345678',
      },
      ttw: {
        showGdprDisclaimer: false,
      },
      setup: {
        password: '$2a$12$3TOQyw0rp9Nhw9gxNvEZ0eH9EkHvVUdmlPC9wxtNZUxvmZ3MsnrG6',
      },
      enableDeliveryProvider: false,
      handedOff: {
        isEnable: false,
        requestReason: false,
      },
    },
  },
};
